// Custom withRouter HOC for React Router v6
// This replaces the removed withRouter from react-router-dom v5
// Used for class components that need navigation
import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

const withRouter = WrappedComponent => {
  const WithRouterWrapper = props => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    // Create a history-like object for backward compatibility
    const history = {
      push: navigate,
      replace: path => navigate(path, { replace: true }),
      goBack: () => navigate(-1),
      location
    };

    // Create a match-like object for backward compatibility.
    // path mirrors pathname (not the v5 route pattern): every consumer
    // compares it against literal paths like '/create' or '/edit', so the
    // pathname satisfies them (EditPromptPage relies on this to tell
    // create mode from edit mode)
    const match = {
      params,
      url: location.pathname,
      path: location.pathname
    };

    return (
      <WrappedComponent
        {...props}
        navigate={navigate}
        location={location}
        params={params}
        history={history}
        match={match}
      />
    );
  };

  // Preserve the display name for debugging
  WithRouterWrapper.displayName = `withRouter(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  return WithRouterWrapper;
};

export default withRouter;
